<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'component_tag_history.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-input
        type="number"
        class="input-field"
        [(ngModel)]="componentTag"
        placeholder="{{ 'component_tag_history.component_tag_id_placeholder' | translate }}"
      />
      <ion-button
        [color]="'primary'"
        fill="solid"
        [disabled]="!componentTag"
        (click)="getcomponentTagHistory(componentTag.toString())"
        >{{ 'component_tag_history.get_history' | translate }}</ion-button
      >
      <ion-button (click)="scanTag()" [color]="'warning'" fill="solid">
        <ion-icon name="camera-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="close()" [color]="'danger'" fill="solid">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ui-table [zTableModel]="tableModel"></ui-table>
</ion-content>
